<template>
  <!-- Serach Result -->
  <v-container class="search-results py-0" :class="{ inset: inset }">
    <v-row class="headline">
      <v-col cols="12">
        <b class="primary--text">{{ totalResults }}</b> resultado(s)
      </v-col>
    </v-row>
    <v-row align="center" class="mt-n3">
      <v-col>
        <hr />
      </v-col>
      <v-col class="flex-grow-0" v-if="showAddButton">
        <router-link :to="{ name: addButtonDestiny }">
          <v-btn fab depressed small outlined color="var(--gray-light)">
            <v-icon size="14" color="var(--gray)">fal fa-plus</v-icon>
          </v-btn>
        </router-link>
      </v-col>
      <v-col class="flex-grow-0" v-if="showFilterButton">
        <v-btn fab depressed small outlined color="var(--gray-light)" @click="$emit('filterButtonClick')">
          <v-icon size="14" color="var(--gray)">fal fa-filter</v-icon>
        </v-btn>
      </v-col>
      <v-col class="flex-grow-0" v-if="showExcelButton">
        <v-btn fab depressed small outlined color="var(--gray-light)" @click="$emit('excelButtonClick')">
          <v-icon size="14" color="var(--gray)">fal fa-file-excel</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center" class="mt-n4">
      <v-col class="result-chips">
        <v-chip
          @click:close="remove(filterValue)"
          close
          dark
          color="var(--secondary)"
          v-for="filterValue in items"
          :key="filterValue"
          >{{ filterValue }}</v-chip
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    inset: Boolean,
    value: {
      type: Array,
      required: true
    },
    totalResults: {
      type: Number,
      default: 0
    },
    addButtonDestiny: {
      type: String,
      default: ""
    },
    showAddButton: {
      type: Boolean,
      default: true
    },
    showFilterButton: {
      type: Boolean,
      default: false
    },
    showExcelButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: []
    };
  },
  watch: {
    value() {
      this.items = this.value;
    }
  },
  methods: {
    remove(filterValue) {
      this.items.splice(this.items.indexOf(filterValue), 1);
      this.$emit("input", this.items);
      this.$emit("itemRemoved");
    }
  }
};
</script>